import script from "./paginacaoComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./paginacaoComponent.vue?vue&type=script&setup=true&lang=js"

import "./paginacaoComponent.vue?vue&type=style&index=0&id=2000c51e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2000c51e"]])

export default __exports__